export enum OfferPath {
  TalentPool = 'talent_pools',
  Job = 'offers',
}

export enum OfferStatus {
  Draft = 'draft',
  Published = 'published',
  Internal = 'internal',
  Closed = 'closed',
  Archived = 'archived',
}

export enum OfferKind {
  Job = 'job',
  TalentPool = 'talent_pool',
}
